import { render, staticRenderFns } from "./comm-from-vuePdf.vue?vue&type=template&id=578cc048&scoped=true&"
import script from "./comm-from-vuePdf.vue?vue&type=script&lang=js&"
export * from "./comm-from-vuePdf.vue?vue&type=script&lang=js&"
import style0 from "./comm-from-vuePdf.vue?vue&type=style&index=0&id=578cc048&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578cc048",
  null
  
)

export default component.exports